import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
 static targets = ["content"]

  close() {
    this.element.remove();
  }

  clickOutside(event) {
    if (!this.contentTarget.contains(event.target)) {
      this.close()
    }
  }
}
